document.getElementById("search-open").onclick = function openShare() {
  document.getElementById("search").classList.add("open");
};
document.getElementById("search-close").onclick = function closeShare() {
    document.getElementById("search").classList.remove("open");
};


// var swiperPDP = new Swiper(".swiper.is-pdp", {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   rewind: 'true',
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: 'true',
//   }
// });

// Initialize thumbnail swiper first
var swiperPDPThumbs = new Swiper(".pdp-thumb-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 10,
  watchSlidesProgress: true,
  allowTouchMove: true,
  centerInsufficientSlides: true,
  width: null
});

// Function to set initial active states
function initializeVariantThumbnails() {
  // Get all unique thumbnail-alt values (colors)
  const uniqueColors = new Set(
    Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
      .map(thumb => thumb.getAttribute('thumbnail-alt'))
      .filter(Boolean)
  );

  // Clear all active states first
  document.querySelectorAll('.pdp-thumb-swiper .swiper-slide').forEach(thumb => {
    thumb.classList.remove('swiper-slide-thumb-active');
  });

  // For each color, set the first thumbnail as active
  uniqueColors.forEach(color => {
    const colorThumbs = Array.from(
      document.querySelectorAll(`.pdp-thumb-swiper .swiper-slide[thumbnail-alt="${color}"]`)
    );
    if (colorThumbs.length > 0) {
      colorThumbs[0].classList.add('swiper-slide-thumb-active');
    }
  });
}

// Modify the existing PDP swiper
var swiperPDP = new Swiper(".swiper.is-pdp", {
  slidesPerView: 1,
  spaceBetween: 15,
  rewind: true,
  width: null,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 15
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 15
    }
  },
  on: {
    init: function() {
      initializeVariantThumbnails();
      this.update();
    }
  }
});

// Update active thumbnail when swiper changes
swiperPDP.on('slideChange', function() {
  const visibleThumbs = Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
    .filter(thumb => thumb.style.display !== 'none');

  visibleThumbs.forEach((thumb, index) => {
    thumb.classList.toggle('swiper-slide-thumb-active', index === this.activeIndex);
  });

  // Ensure active slide is visible
  requestAnimationFrame(() => {
    const activeSlide = document.querySelector('.pdp-swiper .swiper-slide-active');
    if (activeSlide) {
      activeSlide.style.opacity = '1';
      activeSlide.style.visibility = 'visible';
    }
  });
});

// Simple click handler for thumbnails
document.querySelectorAll('.pdp-thumb-swiper .swiper-slide').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const visibleThumbs = Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
      .filter(t => t.style.display !== 'none');

    const thumbIndex = visibleThumbs.indexOf(thumb);
    if (thumbIndex !== -1) {
      swiperPDP.slideTo(thumbIndex);

      // Force opacity update on the new active slide
      requestAnimationFrame(() => {
        const activeSlide = document.querySelector('.swiper.is-pdp .swiper-slide-active');
        if (activeSlide) {
          activeSlide.style.opacity = '1';
          activeSlide.style.visibility = 'visible';
        }
      });
    }
  });
});

// Add variant change handler
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if (variant?.featured_image?.alt) {
    requestAnimationFrame(() => {
      // Reset all first thumbnails for each color variant
      initializeVariantThumbnails();

      // Reset swiper position and update
      swiperPDP.slideTo(0, 0);
      swiperPDP.update();

      // Force opacity update on visible slides
      document.querySelectorAll('.swiper.is-pdp .swiper-slide').forEach(slide => {
        if (slide.style.display !== 'none') {
          slide.style.opacity = '1';
        } else {
          slide.style.opacity = '0';
        }
      });
    });
  }
});


// var swiperFeatured = new Swiper(".swiper.is-hero", {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   loop: 'true',
//   effect: 'fade',
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   breakpoints: {
//     992: {
//       autoHeight: false, //enable auto height
//     }
//   }
// });

var swiperFeatured = new Swiper(".swiper.is-featured", {
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    }
  }
});

var swiperFeatured = new Swiper(".swiper.is-best", {
  slidesPerView: 'auto',
  loop: 'true',
  centeredSlides: 'true',
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");
    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}